// eslint-disable-next-line import/prefer-default-export
export const ACCEPT_HEADER_VALUE_FOR_DOCUMENTS = 'application/json, application/yaml';
